import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import FunctionaryList from './functionaries/FunctionaryList';
import FunctionaryForm from './functionaries/FunctionaryForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addFunctionariesAction } from '../../actions/functionariesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { FUNCIONARIOS_CREAR, PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Functionaries = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addFunctionariesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, FUNCIONARIOS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Funcionarios' 
                subtitle='Personas' 
                nodes={nodes}
                actions={actions}
                component={FunctionaryList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <FunctionaryForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Functionaries;